/**
 * Countries where Stripe opens a Connect Standard account (PD-0043: any of them may
 * collect; the methods follow the country and the currency). Source: Stripe's
 * "Global availability" list for Connect; India is invite-only and left out.
 * Stripe rejects a country it does not serve, so this list only spares the instructor that error.
 */
export const CONNECT_COUNTRIES: readonly string[] = [
  "AE", "AT", "AU", "BE", "BG", "BR", "CA", "CH", "CY", "CZ", "DE", "DK", "EE", "ES", "FI", "FR",
  "GB", "GI", "GR", "HK", "HR", "HU", "IE", "IT", "JP", "LI", "LT", "LU", "LV", "MT", "MX", "MY",
  "NL", "NO", "NZ", "PL", "PT", "RO", "SE", "SG", "SI", "SK", "TH", "US",
];

/** A country's name in the UI language; the code itself when the runtime has no name for it. */
export const countryName = (code: string, locale: string): string => {
  try {
    return new Intl.DisplayNames([locale], { type: "region" }).of(code) ?? code;
  } catch {
    return code;
  }
};

/** The Connect countries as select options, sorted by their name in the UI language. */
export const connectCountryOptions = (locale: string): { code: string; name: string }[] =>
  CONNECT_COUNTRIES.map((code) => ({ code, name: countryName(code, locale) })).sort((a, b) =>
    a.name.localeCompare(b.name, locale),
  );
